import React, { useState } from 'react'
import { Container } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { Grid } from "@material-ui/core"
import { Fragment } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import './message.css'
import { ButtonHLPure } from "../../pures"

/**
 * @function MessagePure
 * @description Componente para mostrar interfaz de validación de código con reenvío por SMS o correo
 * @param {{validationCode: string, focused: boolean, description: string, onlyEmail: boolean, labelBtnOnlyEmail: string, labelTitle: string, cellphoneNumber: string, input: React.RefObject, handleClick: Function, handleFocus: Function, handleBlur: Function, handleChange: Function, handleKeyUp: Function, onReSendMessage: Function, onVerify: Function}} props
 * @returns {React.ReactElement}
 */
function MessagePure(props) {
    const { t } = useTranslation()
    const [numberClic, setNumberClic] = useState(0)

    /**
     * @function resendFunction
     * @description Maneja el reenvío del código incrementando el contador de clics
     * @param {Event} e - Evento del click
     * @param {string} validationType - Tipo de validación ('mail' o 'phoneNumber')
     * @returns {void}
     */
    const resendFunction = (e, validationType) => {
        setNumberClic(numberClic + 1)
        props.onReSendMessage(e, validationType)
    }

    /**
     * @function renderDescriptionWithEmail
     * @description Renderiza la descripción resaltando el correo electrónico en azul
     * @param {string} text - Texto de la descripción
     * @returns {React.ReactElement}
     */
    const renderDescriptionWithEmail = (text) => {
        const emailRegex = /(\([a-zA-Z0-9._*-]+@[a-zA-Z0-9._*-]+\))/g
        const parts = text.split(emailRegex)

        return (
            <p style={{ marginBottom: '20px', textAlign: 'center' }}>
                {parts.map((part, index) => {
                    if (part && part.includes('@')) {
                        return <span key={index} style={{ color: '#427fba', fontWeight: '600' }}>{part}</span>
                    }
                    return <span key={index}>{part}</span>
                })}
            </p>
        )
    }

    const CODE_LENGTH = new Array(6).fill(0)

    const { validationCode, focused, description, onlyEmail, labelBtnOnlyEmail, labelTitle } = props
    const validationCodes = validationCode.split("")

    const hideInput = !(validationCodes.length < CODE_LENGTH.length)

    const selectedIndex = (validationCodes.length < CODE_LENGTH.length) ? validationCodes.length : CODE_LENGTH.length - 1
    const { i18n } = useTranslation();
    const isEnglish = (i18n?.language || 'es').toLowerCase().startsWith('es')


    return (
        <Fragment>
            <div className='message-display-flex' >
                <div className='message-display-block message-container ' spacing={4}>
                    <div item xs={12}>
                        {renderDescriptionWithEmail(description || t('messagePure.description1') + props.cellphoneNumber + t('messagePure.description2'))}
                    </div>
                    <div className='message-container-code'>
                        <label className='message-form-inputs-labels'>{(onlyEmail && labelTitle) ? labelTitle : t('messagePure.code')}</label>
                        <div className="message-wrap" onClick={props.handleClick}>
                            <input
                                autoFocus
                                value=""
                                ref={props.input}
                                onFocus={props.handleFocus}
                                onBlur={props.handleBlur}
                                onChange={props.handleChange}
                                onKeyUp={props.handleKeyUp}
                                className="message-input"
                                style={{
                                    width: "32px",
                                    top: "0px",
                                    bottom: "0px",
                                    left: `${selectedIndex * 32}px`,
                                    opacity: hideInput ? 0 : 1,
                                }}
                            />
                            {CODE_LENGTH.map((v, index) => {
                                // return <div className="display">{validationCodes[index]}</div>
                                const selected = validationCodes.length === index
                                const filled =
                                    validationCodes.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1

                                return (
                                    <div className="message-display">
                                        {validationCodes[index]}
                                        {(selected || filled) && focused && <div className="message-shadows" />}
                                    </div>
                                )
                            })}
                        </div>
                        <div className={`message-actions ${onlyEmail ? 'message-actions-onboarding' : ''}`}>
                            <div className="message-actions-center">
                                {(numberClic > 1 || onlyEmail) ? (
                                    <ButtonHLPure
                                        className="message-button-accept-user"
                                        onClickBtn={(e) => resendFunction(e, 'mail')}
                                        nameBtn={
                                            (onlyEmail && labelBtnOnlyEmail)
                                                ? labelBtnOnlyEmail
                                                : t('messagePure.resendCodeEmail')
                                        }
                                    />
                                ) : (
                                    <Button
                                        className="message-button-accept-user"
                                        onClick={(e) => resendFunction(e, 'phoneNumber')}
                                    >
                                        {t('messagePure.resendCodeSMS')}
                                    </Button>
                                )}
                            </div>

                            {props.onBack && (
                                <div className="message-actions-center">
                                    <ButtonHLPure
                                        className="message-button-accept-user"
                                        onClickBtn={props.onBack}
                                        nameBtn={props.labelBackBtn || t('button.return')}
                                    />
                                </div>
                            )}

                            {props.onVerify && (
                                <div className="message-actions-right">
                                    <ButtonHLPure
                                        primary
                                        className="message-button-accept-user"
                                        onClickBtn={props.onVerify}
                                        nameBtn={t('messagePure.verify.code')}
                                    />
                                </div>
                            )}
                        </div>


                    </div>
                </div>
            </div>
        </Fragment >
    )
}

export { MessagePure as default }
